import React from 'react';
import ShowJsonImage from './windows/wint/ShowJsonImage';
import './handle_promo.css';

const Warehouse = () => {
  const images = [
    { quoteId: 22, quoteItemId: 122, zoom: 0.75, specs: 'Specs for item 122' },
    { quoteId: 21, quoteItemId: 116, zoom: 0.75, specs: 'Specs for item 116' },
    { quoteId: 22, quoteItemId: 122, zoom: 0.75, specs: 'Specs for item 130' },
    { quoteId: 21, quoteItemId: 116, zoom: 0.75, specs: 'Specs for item 140' },
  ];

  return (
    <div className="content-container">
      <h1>Warehouse</h1>
      <p>This is the Warehouse page.</p>

      <div className="warehouse-grid">
        {/* Loop through each image/spec pair */}
        {images.map((img, index) => (
          <React.Fragment key={`${img.quoteItemId}-${index}`}>
            <div className="image-cell">
              <ShowJsonImage
                quoteId={img.quoteId}
                quoteItemId={img.quoteItemId}
                zoom={img.zoom}
              />
            </div>
            <div className="specs-cell">
              <h3>Item #{img.quoteItemId}</h3>
              <p>{img.specs}</p>
            </div>
          </React.Fragment>
        ))}

        {/* The vertical property panel */}
        <div className="property-panel">
          <h2>Financing Options</h2>
          <p>0% APR for 12 months</p>
          <p>Promo: 10% off for first-time buyers</p>
          <h3>Total Prices</h3>
          <p>Subtotal: $TBD</p>
          <p>Tax: $TBD</p>
          <p>Total: $TBD</p>
          <button>Apply Financing</button>
          <button>Redeem Promo</button>
        </div>
      </div>
    </div>
  );
};

export default Warehouse;



/*
import React from 'react';
import ShowJsonImage from './windows/wint/ShowJsonImage';

const Warehouse = () => (
    <div className="content-container">
        <h1>Warehouse</h1>
        <p>This is the Warehouse page.</p>
        <div style={{ border: '0px solid green', margin: '10px 10px 0 10px' }}>
            <ShowJsonImage quoteId = {22} quoteItemId = {122} zoom={1}/></div>
        <div style={{ border: '0px solid green', margin: '10px' }}>
            <ShowJsonImage quoteId = {21} quoteItemId = {116} zoom={1}/></div>
    </div>
);

export default Warehouse;
*/